/* ----------------- Globals --------------- */
import { ScrollView } from "react-native";

/* ----------------- UI --------------- */
import { CustomChip, TooltipWrapper, useDevice } from "@memorang/ui";

/* ----------------- Helpers --------------- */
import { isWeb } from "../../helpers/platform";

import { useAppTheme } from "@hooks/useAppTheme";
/* ----------------- Components --------------- */
import type { QuickActionsChipType } from "./types";

/* ----------------- Types --------------- */

type Props = {
	quickActionsChips: QuickActionsChipType[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
};
export const QuickActionChips = ({
	quickActionsChips,
	handleQuickActionPress,
}: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			contentContainerStyle={{
				gap: 8,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			{quickActionsChips?.map((chip) => {
				const Content = () => (
					<CustomChip
						icon={chip.icon}
						mode="outlined"
						textStyle={{ fontSize: theme.fonts.labelLarge.fontSize }}
						onPress={() => {
							handleQuickActionPress(chip.type);
						}}
					>
						{chip.label}
					</CustomChip>
				);
				return isWeb ? (
					<TooltipWrapper title={chip.tooltip} key={chip.label}>
						<Content />
					</TooltipWrapper>
				) : (
					<Content key={chip.label} />
				);
			})}
		</ScrollView>
	);
};
